import React from 'react';
import { useLocation } from 'react-router-dom';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import 'swiper/swiper-bundle.min.css';
import HomeTile from '../../../components/HomeList/HomeTile/HomeTile';
import useWindowSize from '../../../hooks/useWindowSize';
import sliderLeftArrow from '../../../images/portal/icons/sliderLeftArrow.svg';
import sliderRightArrow from '../../../images/portal/icons/sliderRightArrow.svg';
import ItemsGridSwiperStyles from './ItemsGridSwiper.styled';
import { fireSegmentEvent } from '../../../utils';

export const ItemsGridSwiper = ({
  listItems,
  swiperID,
  dealer,
  homes,
  retailEventLabel,
}) => {
  const [width, height] = useWindowSize();
  const isMobile = width <= 650;
  const isTablet = width <= 1099;
  const location = useLocation();

  const handleHomeClick = (home) => {
    fireSegmentEvent('Facility Model Clicked', {
      baths: home?.baths,
      beds: home?.beds,
      modelName: home?.name || home?.modelName || '',
      basePrice: parseInt(home?.priceSort) || 0,
      length: 0,
      width: 0,
      modelSquareFeet: home?.squareFeet,
      modelNumber: home?.modelNumber || '',
      serialNumber: home?.serialNumber || '',
      eventContext: retailEventLabel || '',
    });
  };

  return (
    <ItemsGridSwiperStyles>
      <div className="DXItemsGrid-swiper-wrap">
        <Swiper
          slidesPerView={isMobile ? 1.1 : isTablet ? 2.1 : 3}
          centeredSlides={isMobile ? true : isTablet ? false : false}
          centeredSlidesBounds={isMobile ? true : isTablet ? false : false}
          navigation={{
            nextEl: `.${swiperID}-next`,
            prevEl: `.${swiperID}-prev`,
          }}
          modules={[Navigation]}
        >
          {listItems?.map((slide, i) => (
            <SwiperSlide key={slide?.id || 'slide' + i}>
              <HomeTile
                retailHomeObject={slide.retailHomeObject}
                dealer={dealer}
                cardLinkState={{
                  dealer: dealer,
                  homes: homes,
                  homesOffset: null,
                  filter: null,
                  prevPath: location.pathname,
                }}
                handleClick={(e) => {
                  handleHomeClick(slide.retailHomeObject);
                }}
                noSwipe
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <img
          className={`DXItemsGrid-arrow-next ${swiperID}-next`}
          src={sliderRightArrow}
          alt={'next arrow icon'}
        />
        <img
          className={`DXItemsGrid-arrow-prev ${swiperID}-prev`}
          src={sliderLeftArrow}
          alt={'prev arrow icon'}
        />
      </div>
    </ItemsGridSwiperStyles>
  );
};

export default ItemsGridSwiper;
